function E4Custom () {

  let self = this;

  /**
   * Filter images by color
   */
  this.filterSlides = function (color, slick) {
    if (! color) {
      return;
    }

    color = color.toLowerCase().replace(' ', '-');

    if (! slick.length) {
      return;
    }

    slick.slick('slickUnfilter');
    slick.slick('slickFilter', function (index, item) {
      let el = $(item),
        isVisible = false;

      if ('any' === el.data('color') || 'any' === color || color === el.data('color')) {
        isVisible = true;
        el.show();
      }

      return isVisible;
    });

    // Update the slide indexes, without it sliders pg__mains and pg__thumbs aren't synchronized after filtering
    let slickIndex = 0;
    slick.find('.slick-track > .slick-slide').each(function () {
      let item = $(this);
      item.data('slick-index', slickIndex).attr('data-slick-index', slickIndex);
      slickIndex++;
    });
  }

  /**
   * Add events on color change
   */
  this.onColorChange = function () {
    let selectors = BT.selectors.productGroup;
    $(document).on('click change', selectors.optionValue, function(e) {
      let el = $(this),
        wrap = el.parents(selectors.wrap).first(),
        handle = wrap.attr('data-product-handle'),
        color;

      // For the select under the sticky ATC
      if ('select' === el.prop('tagName').toLowerCase()) {
        if ('click' === e.type) {
          return;
        }

        if ('color' === el.attr('aria-label').toLowerCase() || 'color' === el.parents('.pg__option').data('option-name')) {
          color = el.val();
        }
      }
      // For the color swatches
      else {
         color = el.data('color-value');
      }

      // Update sliders
      let areaSelector = '';
      if (self.isQuickViewPopup()) {
      	areaSelector = '#quickViewPopup ';
      }

      let slickMain = $(areaSelector + '.pg__mains.slick-slider');
      self.filterSlides(color, slickMain);

      let slickThumbs = $(areaSelector + '.pg__thumbs.slick-slider');
      self.filterSlides(color, slickThumbs);
    });

    return self;
  }

  /**
   * Filter the main slides on page load
   */
  this.onMainSlickInit = function () {
    $(document).on('init', '.pg__mains.slick-slider', function(event, slick, currentSlide, nextSlide) {
      self._slickInitProcess('.pg__mains.slick-slider');
    });

    return self;
  }

  /**
   * Filter the thumb slides on page load
   */
  this.onThumbSlickInit = function () {
    $(document).on('init', '.pg__thumbs.slick-slider', function(event, slick, currentSlide, nextSlide) {
      self._slickInitProcess('.pg__thumbs.slick-slider');
    });

    return self;
  }

  /**
   * Check if the quick view popup is opened
   */
  this.isQuickViewPopup = function() {
    return $('body').hasClass('modal-open');
  }

  /**
   * Detect current color and filter images
   */
  this._slickInitProcess = function(slickSelector) {
  	setTimeout(function() {
      if (self.isQuickViewPopup()) {
		slickSelector = '#quickViewPopup ' + slickSelector;
      }

      let selectedColor = $(slickSelector + ' .slick-slide:visible:first').data('color');
      if (selectedColor) {
        let slick = $(slickSelector);
        self.filterSlides(selectedColor, slick);
      }
    }, 100);
  }

  /**
   * Change data of the spec table
   */
  this.setSpecData = function(sku) {
    if (! window.productSpecData || ! sku || ! window.productSpecData[sku]) {
      return;
    }

    let fields = window.productSpecKeys;
    let table = $('#productSpecContentTable tbody');

    for (let field of fields) {
      	let value = 'No';
        if (window.productSpecData[sku][field]) {
          value = window.productSpecData[sku][field];
        }

    	table.find('> tr.spec-' + field + ' > td.data').text(value);
    }
  }

  /**
   * Add spec tab for product page
   */
  this.initSpecData = function() {
  	if (window.productSpecContent) {
      $.getJSON('https://api.e4hats.com/v1/spec.php').done(function(data) {
        const result = JSON.parse(JSON.stringify(data, null, 2));

        if (result.success) {
          $('#productSpecTabContent').html(window.productSpecContent);
          self.setSpecData(window.currentVariantSku);
          $('#productSpecTab, #productSpecMobileTab').show();
        }
      });
    }

    return self;
  }

  /**
   * Change spec data when variant is changed
   */
  this.changeSpecData = function() {
  	self.specDataInterval = setInterval(function() {
      if (! BT || ! BT.updateNewVariant) {
      	return;
      }

      clearInterval(self.specDataInterval);

      $.extend(true, BT, {
        updateNewVariantOrig: BT.updateNewVariant,
        updateNewVariant: function(t, o, n, d, e, i, a) {
          if (o.sku) {
            let currentVariantSku = o.sku;
            self.setSpecData(currentVariantSku);
          }

          return this.updateNewVariantOrig(t, o, n, d, e, i, a);
        }
      });
    }, 500);

    return self;
  }

  /**
   * Init parts data
   */
  this.initPartsData = function(el) {
    let hidden = 0;
    
    el.find('.find-product-handle-by-sku').each((n, b) => {
      const btn = $(b).removeClass('find-product-handle-by-sku');

      this.findProductHandleBySKU(btn.data('sku'), function(products) {
        if (products.length) {
          btn.attr('href', '/products/' + products[0]['handle']).addClass('button--qv');
        } else {
          hidden++;
  
          if (hidden < 2) {
            btn.hide();
          } else {
            btn.closest('.customized-product-parts').hide();
          }
        }
      })
      
    });
    
  }

  this.findProductHandleBySKU = function(SKU, callback) {    
    if (! SKU) {
      return;
    }

    $.getJSON(window.Shopify.routes.root + 'search/suggest.json', {
      q: SKU,
      resources: {
        type: "product",
        limit: 1,
        options: {
          fields: "variants.sku"
        }
      }
    }).done(response => callback(response?.resources?.results?.products ?? []));
  }

  /**
   * Open the mobile submenu after clicking on the top-level menu item 
   */
  this.adjustMobileMenu = function() {
    $('.mobile-nav').on('click', 'li > .mobile-nav__top-link-wrap > a.mobile-nav__item__top-link, li > .mobile-nav__level2-wrap-style2 > a.mobile-nav__level2', function(e) {
      const href = this.getAttribute('href');
      const arrow = $(this).next('a.mobile-nav__arrow');
      
      if (! href || '#' === href || arrow.length) {
        e.preventDefault();
        arrow.click();
        return false;
      }
    });
    
    return self;
  }
}

jQuery(document).ready(function ($) {
  let custom = new E4Custom;
  custom.onColorChange().onMainSlickInit().onThumbSlickInit();

  custom.initSpecData().changeSpecData();
  custom.adjustMobileMenu();

  custom.initPartsData($(document));
  $(document).on('show.bs.modal', function() {
    custom.initPartsData($(this));
  });
  
});
